import React, { useState } from "react";

export default function BusinessWebsiteProfessionalTemplate() {
    const sample = {
        name: "Company Name",
        tagline: "Reliable • Professional • Trusted",
        logo: "/assets/profile.jpg",
        cover: "/assets/cover.jpg",
        phone: "+977 9800000000",
        email: "info@business.com",
        address: "Kathmandu, Nepal",
        website: "https://dialnepal.com.np/sharadakhatiwada",

        services: [
            { title: "Consulting", desc: "Business strategy, growth planning and execution." },
            { title: "Design", desc: "Branding, UI/UX design and creative direction." },
            { title: "Development", desc: "Web & mobile development with scalable architecture." },
            { title: "Marketing", desc: "Digital marketing, SEO & performance campaigns." },
        ],

        gallery: [
            "/assets/gallery1.jpg",
            "/assets/gallery2.jpg",
            "/assets/gallery3.jpg",
            "/assets/gallery4.jpg",
        ],

        videos: [
            "https://www.youtube.com/embed/dQw4w9WgXcQ",
            "https://www.youtube.com/embed/jNQXAC9IVRw",
        ],

        testimonials: [
            { name: "Rohit K.", rating: 5, text: "Excellent services and very professional team." },
            { name: "Sita P.", rating: 5, text: "Clear communication and timely delivery." },
        ],

        hours: [
            ["Mon - Fri", "09:00 AM - 07:00 PM"],
            ["Saturday", "10:00 AM - 05:00 PM"],
            ["Sunday", "Closed"],
        ],
    };

    const [tab, setTab] = useState("photos");
    const [booking, setBooking] = useState({ date: "", time: "", name: "", phone: "" });
    const [contact, setContact] = useState({ name: "", email: "", message: "" });

    const handleBookingChange = (e) => setBooking((s) => ({ ...s, [e.target.name]: e.target.value }));
    const handleContactChange = (e) => setContact((s) => ({ ...s, [e.target.name]: e.target.value }));

    const handleBookSubmit = (e) => {
        e.preventDefault();
        // integrate booking API later
        alert(`Booking requested:\n${booking.name}\n${booking.phone}\n${booking.date} ${booking.time}`);
    };

    const handleContactSubmit = (e) => {
        e.preventDefault();
        // integrate contact API later
        alert(`Message sent:\n${contact.name}\n${contact.email}\n${contact.message}`);
        setContact({ name: "", email: "", message: "" });
    };

    return (
        <div className="bg-light">

            {/* NAVBAR */}
            <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom shadow-sm">
                <div className="container">
                    <a className="navbar-brand d-flex align-items-center gap-2" href="#">
                        <img src={sample.logo} alt="logo" width="48" height="48" className="rounded-circle border" />
                        <div className="d-none d-md-block">
                            <div className="fw-bold text-dark">{sample.name}</div>
                            <small className="text-muted">{sample.tagline}</small>
                        </div>
                    </a>

                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navMenu">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navMenu">
                        <ul className="navbar-nav ms-auto align-items-lg-center">
                            <li className="nav-item mx-2"><a className="nav-link text-dark fw-semibold" href="#about">About</a></li>
                            <li className="nav-item mx-2"><a className="nav-link text-dark fw-semibold" href="#services">Services</a></li>
                            <li className="nav-item mx-2"><a className="nav-link text-dark fw-semibold" href="#media">Media</a></li>
                            <li className="nav-item mx-2"><a className="nav-link text-dark fw-semibold" href="#reviews">Reviews</a></li>
                            <li className="nav-item mx-2"><a className="nav-link text-dark fw-semibold" href="#contact">Contact</a></li>
                            <li className="nav-item mx-2">
                                <a className="btn btn-outline-primary px-3 fw-semibold" href="#book">
                                    <i className="bi bi-calendar-check me-1"></i> Book
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            {/* HERO */}
            <header
                className="d-flex align-items-center justify-content-center text-center"
                style={{
                    minHeight: 340,
                    padding: "40px 20px",
                    background: "linear-gradient(135deg, #e8ecf3, #d4dae4, #c2cad8)",
                    borderBottom: "1px solid #cbd3df",
                }}
            >
                <div>
                    {/* Profile Image */}
                    <img
                        src={sample.logo}
                        alt="logo"
                        width="130"
                        height="130"
                        className="rounded-circle shadow-sm border mb-3"
                        style={{ objectFit: "cover" }}
                    />

                    {/* Business Name */}
                    <h1 className="fw-bold text-dark mb-2" style={{ fontSize: "2.3rem" }}>
                        {sample.name}
                    </h1>

                    {/* Tagline / What Service They Provide */}
                    <p className="text-muted fs-5" style={{ maxWidth: 600, margin: "0 auto" }}>
                        {sample.tagline}
                    </p>
                </div>
            </header>


            {/* MAIN */}
            <main className="container my-5">
                <div className="row g-4">

                    {/* LEFT column */}
                    <div className="col-lg-8">

                        {/* ABOUT */}
                        <section id="about" className="mb-4">
                            <div className="card border-0 shadow-sm">
                                <div className="card-body">
                                    <h3 className="fw-bold mb-3">About Us</h3>
                                    <p className="text-muted">
                                        We are a professional firm delivering high-quality services with integrity and commitment.
                                        Our team of experts ensures results that matter — on time, every time.
                                    </p>

                                    <div className="row text-center mt-4">
                                        <div className="col-4">
                                            <div className="text-primary fs-3"><i className="bi bi-people-fill"></i></div>
                                            <div className="fw-semibold">12+</div>
                                            <small className="text-muted">Staff</small>
                                        </div>
                                        <div className="col-4">
                                            <div className="text-success fs-3"><i className="bi bi-calendar2-check-fill"></i></div>
                                            <div className="fw-semibold">120+</div>
                                            <small className="text-muted">Bookings / mo</small>
                                        </div>
                                        <div className="col-4">
                                            <div className="text-warning fs-3"><i className="bi bi-award-fill"></i></div>
                                            <div className="fw-semibold">5+</div>
                                            <small className="text-muted">Years</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* SERVICES */}
                        <section id="services" className="mb-4">
                            <h4 className="fw-bold mb-3">Our Services</h4>
                            <div className="row g-3">
                                {sample.services.map((s, i) => (
                                    <div className="col-md-6" key={i}>
                                        <div className="card h-100 border-0 shadow-sm">
                                            <div className="card-body">
                                                <h5 className="fw-semibold">{s.title}</h5>
                                                <p className="text-muted small">{s.desc}</p>
                                                <a href="#book" className="btn btn-sm btn-primary">Book</a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* MEDIA TABS (Images + Videos) */}
                        <section id="media" className="mb-4">
                            <h4 className="fw-bold mb-3">Media</h4>

                            <ul className="nav nav-tabs mb-3" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className={`nav-link ${tab === "photos" ? "active" : ""}`} onClick={() => setTab("photos")}>Photos</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className={`nav-link ${tab === "videos" ? "active" : ""}`} onClick={() => setTab("videos")}>Videos</button>
                                </li>
                            </ul>

                            {tab === "photos" ? (
                                <div className="row g-3">
                                    {sample.gallery.map((img, i) => (
                                        <div className="col-md-6" key={i}>
                                            <div className="rounded overflow-hidden shadow-sm">
                                                <img src={img} alt={`gallery-${i}`} className="w-100" style={{ height: 260, objectFit: "cover" }} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="row g-3">
                                    {sample.videos.map((v, i) => (
                                        <div className="col-md-6" key={i}>
                                            <div className="ratio ratio-16x9 shadow-sm rounded overflow-hidden">
                                                <iframe src={v} title={`video-${i}`} allowFullScreen></iframe>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </section>

                        {/* TESTIMONIALS */}
                        <section id="reviews" className="mb-4">
                            <h4 className="fw-bold mb-3">Customer Reviews</h4>
                            <div className="row g-3">
                                {sample.testimonials.map((t, i) => (
                                    <div className="col-md-6" key={i}>
                                        <div className="card border-0 shadow-sm h-100">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center mb-2">
                                                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center me-3" style={{ width: 48, height: 48 }}>
                                                        <i className="bi bi-person text-muted"></i>
                                                    </div>
                                                    <div>
                                                        <div className="fw-semibold">{t.name}</div>
                                                        <div className="text-warning small">{'★'.repeat(t.rating)}</div>
                                                    </div>
                                                </div>
                                                <p className="mb-0 text-muted">{t.text}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>

                    </div>

                    {/* RIGHT column */}
                    <aside className="col-lg-4">

                        {/* CONTACT CARD */}
                        <div className="card border-0 shadow-sm mb-4">
                            <div className="card-body">
                                <h5 className="fw-bold mb-3">Get in touch</h5>
                                <p className="mb-1"><i className="bi bi-telephone me-2 text-primary"></i> <a href={`tel:${sample.phone}`}>{sample.phone}</a></p>
                                <p className="mb-1"><i className="bi bi-envelope me-2 text-secondary"></i> <a href={`mailto:${sample.email}`}>{sample.email}</a></p>
                                <p className="mb-0"><i className="bi bi-geo-alt me-2 text-success"></i> {sample.address}</p>

                                <div className="d-grid gap-2 mt-3">
                                    <a className="btn btn-primary" href={`tel:${sample.phone}`}><i className="bi bi-telephone me-2"></i>Call</a>
                                    <a className="btn btn-outline-primary" href={sample.website} target="_blank" rel="noreferrer"><i className="bi bi-globe2 me-2"></i>Visit Site</a>
                                </div>
                            </div>
                        </div>

                        {/* HOURS */}
                        <div className="card border-0 shadow-sm mb-4">
                            <div className="card-body">
                                <h6 className="fw-bold">Operating Hours</h6>
                                <ul className="list-unstyled mb-0">
                                    {sample.hours.map((h, i) => (
                                        <li key={i} className="d-flex justify-content-between py-2 border-bottom">
                                            <small className="text-muted">{h[0]}</small>
                                            <small className={h[1] === "Closed" ? "text-danger" : ""}>{h[1]}</small>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* BOOKING FORM */}
                        <div className="card border-0 shadow-sm mb-4" id="book">
                            <div className="card-body">
                                <h6 className="fw-bold mb-3">Book Appointment</h6>
                                <form onSubmit={handleBookSubmit}>
                                    <div className="mb-2">
                                        <label className="form-label small">Date</label>
                                        <input type="date" name="date" value={booking.date} onChange={handleBookingChange} className="form-control form-control-sm" required />
                                    </div>
                                    <div className="mb-2">
                                        <label className="form-label small">Time</label>
                                        <select name="time" value={booking.time} onChange={handleBookingChange} className="form-select form-select-sm" required>
                                            <option value="">Select time</option>
                                            <option>10:00 AM</option>
                                            <option>12:00 PM</option>
                                            <option>03:00 PM</option>
                                            <option>05:00 PM</option>
                                        </select>
                                    </div>
                                    <div className="mb-2">
                                        <input name="name" placeholder="Your name" className="form-control form-control-sm" value={booking.name} onChange={handleBookingChange} required />
                                    </div>
                                    <div className="mb-2">
                                        <input name="phone" placeholder="Phone" className="form-control form-control-sm" value={booking.phone} onChange={handleBookingChange} required />
                                    </div>
                                    <button className="btn btn-primary w-100">Confirm Booking</button>
                                </form>
                            </div>
                        </div>

                        {/* CONTACT FORM */}
                        <div className="card border-0 shadow-sm">
                            <div className="card-body">
                                <h6 className="fw-bold mb-3">Send a Message</h6>
                                <form onSubmit={handleContactSubmit}>
                                    <div className="mb-2">
                                        <input name="name" value={contact.name} onChange={handleContactChange} className="form-control form-control-sm" placeholder="Your name" required />
                                    </div>
                                    <div className="mb-2">
                                        <input name="email" value={contact.email} onChange={handleContactChange} className="form-control form-control-sm" placeholder="Your email" required />
                                    </div>
                                    <div className="mb-2">
                                        <textarea name="message" value={contact.message} onChange={handleContactChange} className="form-control form-control-sm" rows="3" placeholder="Message" required></textarea>
                                    </div>
                                    <div className="d-grid">
                                        <button className="btn btn-outline-primary">Send</button>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </aside>
                </div>
            </main>

            {/* FOOTER */}
            <footer className="bg-white border-top mt-5">
                <div className="container py-4 text-center text-muted">
                    <div className="fw-bold">{sample.name}</div>
                    <small>© {new Date().getFullYear()} {sample.name}. All rights reserved.</small>
                </div>
            </footer>

        </div>
    );
}
